export enum Spacing {
    pagePadding = "0 24px",
    contentMaxWidth = "1200px",
}
